import { useCallback, useRef, useState } from 'react';
export const useAccessIcfPrompt = (requiresWarning) => {
    const [isPromptOpen, setIsPromptOpen] = useState(false);
    const pendingActionRef = useRef(null);
    const requestOpen = useCallback((action) => {
        if (!requiresWarning) {
            action();
            return;
        }
        pendingActionRef.current = action;
        setIsPromptOpen(true);
    }, [requiresWarning]);
    const onConfirm = useCallback(() => {
        const action = pendingActionRef.current;
        pendingActionRef.current = null;
        setIsPromptOpen(false);
        action?.();
    }, []);
    const onCancel = useCallback(() => {
        pendingActionRef.current = null;
        setIsPromptOpen(false);
    }, []);
    const onClose = useCallback(() => {
        setIsPromptOpen(false);
    }, []);
    return { requestOpen, isPromptOpen, onConfirm, onCancel, onClose };
};
